<template>
  <!-- 大咖-新闻详情 -->
  <div class="masterInfoWrap">
      <h1>{{detail.title}}</h1>
      <div class="souce">来源：<span>{{detail.source }}</span> <span>{{detail.createTime}}</span></div>
      <video :src="detail.vodAddr" ref="video" playsinline webkit-playsinline :poster="detail.imageAddr" loop controls autoplay preload v-if="detail.contentType === 1" width="100%"></video>
      <div class="masterInfoContent" v-html="detail.detail" v-else></div>
      <!-- 底部 -->
      <div class="footerLine">－ 我是有底线的 －</div>
      <!-- <div :style="{display: 'none'}" @click="playVideo()"></div> -->
  </div>
</template>

<script>
import '../js/flexible.debug.js'
export default {
  data () {
    return {
      detail: '',
    }
  },
  created(){
    this.init();
  },
  mounted(){
    
  },
  methods:{
    init(){
      this.$http.get("content/industry/front/page/query/id?frontPageId="+this.$route.query.contentId+'&accountId='+this.$route.query.accountId)
				.then((response) => {
          this.detail = response.respData
				});
    },

    // playVideo () {

    // }
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped lang="less">
.masterInfoWrap{
  width: 100%;
  height: auto;
  padding: 0.4rem;
  h1{
    line-height: 0.75rem;
    font-size: 0.53rem;
    color: #333440;
    font-weight: bold;
    margin-bottom: 0.27rem;
  }
  .souce{
    font-size: 0.32rem;
    color: #A4A4A4;
    margin-bottom: 0.37rem;
  }
  .footerLine{
    text-align: center;
    font-size: 0.32rem;
    margin-top: 0.72rem;
    color: #D1D1D1;
  }
}

</style>
<style lang="less">
  .masterInfoContent{
    width:100%;
    overflow: hidden;
    font-size:32px;
    img,video,table{
      max-width: 100%;
    }
  }
</style>



// WEBPACK FOOTER //
// src/pages/masterInfo.vue